// import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
// import axiosInstance from 'Services/APIService';
// import { Service, ServicesState, Role } from 'types/ndisSection/manageServicesTypes';

// const initialState: ServicesState = {
//   services: [],
//   roles: [],
//   loading: false,
//   error: null
// };

// export const fetchServices = createAsyncThunk(
//   'manageServices/fetchServices',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await axiosInstance.get('/service/get-service-list');
//       return response.data as Service[];
//     } catch (error: any) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to fetch services');
//     }
//   }
// );

// export const addService = createAsyncThunk(
//   'manageServices/addService',
//   async (
//     service: Omit<Service, 'service_id' | 'created_by' | 'created_at'>,
//     { rejectWithValue }
//   ) => {
//     try {
//       const payload = {
//         header: service.header,
//         description: service.description,
//         shortDescription: service.shortDescription,
//         roles: service.roles, // Array of role_id strings
//         background: service.background,
//         route: service.route,
//         icon: service.icon,
//         PrimaryRender: service.PrimaryRender
//       };
//       const response = await axiosInstance.post('/service/create-service', payload);
//       return response.data as Service;
//     } catch (error: any) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to add service');
//     }
//   }
// );

// export const updateService = createAsyncThunk(
//   'manageServices/updateService',
//   async (service: Service, { rejectWithValue }) => {
//     try {
//       const payload = {
//         service_id: service.service_id,
//         header: service.header,
//         description: service.description,
//         shortDescription: service.shortDescription,
//         roles: service.roles, // Array of role_id strings
//         background: service.background,
//         route: service.route,
//         icon: service.icon,
//         PrimaryRender: service.PrimaryRender
//       };
//       const response = await axiosInstance.post('/service/update-service', payload);
//       return response.data as Service;
//     } catch (error: any) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to update service');
//     }
//   }
// );

// export const deleteService = createAsyncThunk(
//   'manageServices/deleteService',
//   async (service_id: string, { rejectWithValue }) => {
//     try {
//       const response = await axiosInstance.post('/service/delete-service', { service_id });
//       return service_id;
//     } catch (error: any) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to delete service');
//     }
//   }
// );

// const manageServicesSlice = createSlice({
//   name: 'manageServices',
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchServices.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchServices.fulfilled, (state, action: PayloadAction<Service[]>) => {
//         state.loading = false;
//         state.services = action.payload;
//       })
//       .addCase(fetchServices.rejected, (state, action) => {
//         state.loading = false;
//         state.error = (action.payload as string) || 'Failed to fetch services';
//       })

//       .addCase(addService.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(addService.fulfilled, (state, action: PayloadAction<Service>) => {
//         state.loading = false;
//         state.services.push(action.payload);
//       })
//       .addCase(addService.rejected, (state, action) => {
//         state.loading = false;
//         state.error = (action.payload as string) || 'Failed to add service';
//       })
//       .addCase(updateService.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(updateService.fulfilled, (state, action: PayloadAction<Service>) => {
//         state.loading = false;
//         const index = state.services.findIndex((s) => s.service_id === action.payload.service_id);
//         if (index !== -1) {
//           state.services[index] = action.payload;
//         }
//       })
//       .addCase(updateService.rejected, (state, action) => {
//         state.loading = false;
//         state.error = (action.payload as string) || 'Failed to update service';
//       })
//       .addCase(deleteService.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(deleteService.fulfilled, (state, action: PayloadAction<string>) => {
//         state.loading = false;
//         state.services = state.services.filter((s) => s.service_id !== action.payload);
//       })
//       .addCase(deleteService.rejected, (state, action) => {
//         state.loading = false;
//         state.error = (action.payload as string) || 'Failed to delete service';
//       });
//   }
// });

// export default manageServicesSlice.reducer;


import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';
import { Service, ServicesState, Role } from 'types/ndisSection/manageServicesTypes';

// Interface for fetchServicesByGroup payload
interface ServicePayload {
  email: string;
  group_id: string;
}

const initialState: ServicesState = {
  services: [],
  roles: [],
  loading: false,
  error: null
};

// Existing thunks
export const fetchServices = createAsyncThunk(
  'manageServices/fetchServices',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/service/get-service-list');
      return response.data as Service[];
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch services');
    }
  }
);

export const addService = createAsyncThunk(
  'manageServices/addService',
  async (
    service: Omit<Service, 'service_id' | 'created_by' | 'created_at'>,
    { rejectWithValue }
  ) => {
    try {
      const payload = {
        header: service.header,
        description: service.description,
        shortDescription: service.shortDescription,
        roles: service.roles,
        background: service.background,
        route: service.route,
        icon: service.icon,
        PrimaryRender: service.PrimaryRender
      };
      const response = await axiosInstance.post('/service/create-service', payload);
      return response.data as Service;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to add service');
    }
  }
);

export const updateService = createAsyncThunk(
  'manageServices/updateService',
  async (service: Service, { rejectWithValue }) => {
    try {
      const payload = {
        service_id: service.service_id,
        header: service.header,
        description: service.description,
        shortDescription: service.shortDescription,
        roles: service.roles,
        background: service.background,
        route: service.route,
        icon: service.icon,
        PrimaryRender: service.PrimaryRender
      };
      const response = await axiosInstance.post('/service/update-service', payload);
      return response.data as Service;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update service');
    }
  }
);

export const deleteService = createAsyncThunk(
  'manageServices/deleteService',
  async (service_id: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/service/delete-service', { service_id });
      return service_id;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to delete service');
    }
  }
);

// New thunk for fetching services by group
export const fetchServicesByGroup = createAsyncThunk(
  'manageServices/fetchServicesByGroup',
  async (payload: ServicePayload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/services/get-user-group-service', payload);
      return response.data.services as Service[];
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch services by group');
    }
  }
);

const manageServicesSlice = createSlice({
  name: 'manageServices',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Existing cases
    builder
      .addCase(fetchServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServices.fulfilled, (state, action: PayloadAction<Service[]>) => {
        state.loading = false;
        state.services = action.payload;
      })
      .addCase(fetchServices.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || 'Failed to fetch services';
      })
      .addCase(addService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addService.fulfilled, (state, action: PayloadAction<Service>) => {
        state.loading = false;
        state.services.push(action.payload);
      })
      .addCase(addService.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || 'Failed to add service';
      })
      .addCase(updateService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateService.fulfilled, (state, action: PayloadAction<Service>) => {
        state.loading = false;
        const index = state.services.findIndex((s) => s.service_id === action.payload.service_id);
        if (index !== -1) {
          state.services[index] = action.payload;
        }
      })
      .addCase(updateService.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || 'Failed to update service';
      })
      .addCase(deleteService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteService.fulfilled, (state, action: PayloadAction<string>) => {
        state.loading = false;
        state.services = state.services.filter((s) => s.service_id !== action.payload);
      })
      .addCase(deleteService.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || 'Failed to delete service';
      })
      // New cases for fetchServicesByGroup
      .addCase(fetchServicesByGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServicesByGroup.fulfilled, (state, action: PayloadAction<Service[]>) => {
        state.loading = false;
        state.services = action.payload;
      })
      .addCase(fetchServicesByGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || 'Failed to fetch services by group';
      });
  }
});

export default manageServicesSlice.reducer;